import { call, put, takeLatest } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import { FetchNhtsaDecodedVin } from 'src/constants/actionTypes'
import { ApiService, callClientSecureApi } from './api/callApi'
import { Endpoints } from 'src/constants/endpoints'
import { NhtsaDecodedVin } from 'src/interfaces/nhtsa'
import { captureSentryError } from 'src/utils/sentry'
import { getApiErrorMessage } from 'src/utils/errorHandlers'

interface FetchNhtsaDecodedVinRequest {
  stepId: string
  vin: string
}

function* onFetchNhtsaDecodedVin(
  action: AsyncAction<FetchNhtsaDecodedVinRequest, NhtsaDecodedVin>,
) {
  const { vin, stepId } = action.payload

  try {
    const { payload }: { payload: NhtsaDecodedVin } = yield call(
      callClientSecureApi,
      Endpoints.FetchNhtsaDecodedVin,
      {
        apiService: ApiService.Paraworks,
        query: {
          vin,
          stepId,
        },
      },
    )

    yield put(FetchNhtsaDecodedVin.success())

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.nhtsa.onFetchNhtsaDecodedVin] error',
    })

    const errorMessage = getApiErrorMessage(err, 'Failed to fetch decoded vin')

    yield put(FetchNhtsaDecodedVin.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* nhtsaSaga() {
  yield takeLatest(FetchNhtsaDecodedVin.type.REQUEST, onFetchNhtsaDecodedVin)
}
